// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mi-c";
export var backButton = "_mi-4";
export var backIcon = "_mi-5";
export var chevronShortcut = "_mi-6";
export var container = "_mi-1";
export var editor = "_mi-8";
export var editorWrapper = "_mi-7";
export var prefix = "_mi-2";
export var searchIcon = "_mi-3";
export var suffix = "_mi-9";
export var suffixContent = "_mi-a";
export var suffixText = "_mi-b";
export var wrapper = "_mi-0";